import { ApiClient } from "./core/ApiClient";


export interface ExchangeRate {
    currency: string;
    rates: Map<string, number>;
}

const rateClient = new ApiClient('https://rates.velocorner.com');
const root = '/api/rates';

const listRates = (base: string): Promise<ExchangeRate> => rateClient.get<ExchangeRate>(`${root}/${base}`);
const listHistory = (base: string, counter: string): Promise<Map<string, number>> => rateClient.get<Map<string, number>>(`${root}/historical/${base}/${counter}`);

export const exchangeRateService = {
    listRates,
    listHistory,
}